<template>
    <div>
        <v-item-group
            :model-value="modelValue"
            class="option-btn-group-v2"
            :class="[
                {
                    'option-btn-tall': tallButtons
                },
                btnGridColsClass
            ]"
            :disabled="disabled"
            @update:model-value="onChange($event)"
            v-bind="$attrs"
        >
            <!--
                NOTE: using "value === modelValue" vs "isSelected" is a workaround for a bug in vuetify
                where the isSelected value is not updated when page hydration occurs. Ignore the TS error.
            -->
            <v-item
                v-for="(opt, index) in option.groupValues"
                :key="`item-${index}`"
                :value="opt.value.uid"
                #default="{ isSelected, toggle, value }"
            >
                <v-btn
                    :key="`option-${index}`"
                    variant="outlined"
                    class="rounded"
                    :to="opt.value.path ? `/${opt.value.path}` : void(0)"
                    :class="{
                        'selected': ((value as any) === modelValue),
                        'top-option': 'recommendedValueUid' in option && (option.recommendedValueUid === opt.value.uid),
                        'option-off': optionsDisabledModelSet?.has(opt.value.uid)
                    }"
                    @click="toggle"
                >
                    <strong>{{ opt.value.name }}</strong>
                    <div
                        v-if="!hideDescription && opt.value.description"
                        class="sub-text"
                    >
                        {{ opt.value.description }}
                    </div>
                </v-btn>
            </v-item>
        </v-item-group>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductAttrsGroupOption,
        ProductOptionGroup
    } from '~/types';
    import { useDisplay } from 'vuetify';

    const props = defineProps<{
        modelValue: string;
        option: ProductAttrsGroupOption | ProductOptionGroup;
        optionsDisabledModelSet?: Nilish<Set<string>>;
        disabled?: boolean;
        hideDescription?: boolean;
        disableAutoCols?: boolean;
        tallButtons?: boolean;
    }>();
    
    const emit = defineEmits<{
        'update:modelValue': [value: string];
    }>();

    const { name: displayName } = useDisplay();
    const btnGridColsClass = computed<string>(() => {
        if (props.disableAutoCols) {
            return '';
        }

        if (displayName.value === 'xs') {
            return 'g-col-2';
        }

        return props.option.groupValues.length === 3 ? 'g-col-3' : 'g-col-2';
    });

    function onChange(value: string) {
        if (!props.disabled) {
            emit('update:modelValue', `${value}`);
        }
    }
</script>

<style lang="scss"></style>
